/* eslint-disable */

export enum SummaryType {
	Normal = 0,
	Sum = 1,
	AdminFee = 2,
	Saving = 3,
	Freight = 4,
	ZipDependantFreight = 5,
	Discount = 6,
	OtherFee = 7,
	Ingrid = 8,
	
}
